<template>
  <div class="modal fade" id="kontakt-modal" tabindex="-1" role="dialog" aria-labelledby="kontakt-modalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close p-0" data-dismiss="modal" aria-label="Close">
          <!-- <span class="close" aria-hidden="true"></span> -->
        </button>
        <div class="modal-header"  v-if="!submitted">
          <h5 class="modal-title d-flex font-passion-one" id="kontakt-modalLabel">
            Jetzt Termin zum Probe-Schweißen vereinbaren
          </h5>
        </div>
        <div class="px-3"  v-if="!submitted">
          <p class="mb-0 form-text">
          Geben Sie nachfolgend Ihre persönlichen Daten ein. Wir werden uns daraufhin mit Ihnen in Verbindung setzen.
          </p>
        </div>
        <div class="modal-body">
          <form @submit.prevent="sendData" v-if="!submitted">
            <div class="row">
              <div class="col-12">
                <p class="mb-2 font-weight-bold">
                  Anrede
                </p>
                <div class="form-check form-check-inline">
                  <label class="form-check-label" for="inlineradio3">Frau
                    <input class="form-check-input" type="radio" id="inlineradio3" value="Frau"
                      v-model="salutation" name="salutation">
                    <span class="checkmark"></span>
                  </label>

                  <label class="form-check-label ml-2" for="inlineradio4">Herr
                    <input class="form-check-input" type="radio" id="inlineradio4" value="Herr"
                      v-model="salutation" name="salutation">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="font-weight-bold" for="Vorname">Vorname</label>
                  <input type="text" class="form-control" id="Vorname" name="Vorname" v-model="firstname">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="font-weight-bold" for="Nachname">Nachname</label>
                  <input type="text" class="form-control" id="Nachname" name="Nachname" v-model="lastname">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="font-weight-bold" for="Email">E-Mail*</label>
                  <input type="email" class="form-control" id="Email" name="Email" required v-model="email">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="font-weight-bold" for="Telefon">Telefon</label>
                  <input type="text" class="form-control" id="Telefon" name="Telefon" v-model="phone">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="font-weight-bold" for="ZipCode">Ihre PLZ*</label>
                  <input type="text" class="form-control" id="ZipCode" name="ZipCode" required v-model="zipcode">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="font-weight-bold" for="Stadt">Standort Probe-Schweißen*</label>
                  <input type="text" class="form-control" id="Stadt" name="Stadt" required readonly :value="city">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="font-weight-bold" for="exampleFormControlTextarea1">Anmerkungen (max. 255 Zeichen)</label>
                  <textarea class="form-control anmerkungen" id="exampleFormControlTextarea1" name="exampleFormControlTextarea1" maxlength="255"
                    v-model="comment"></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-check pl-0">
                  <label for="defaultCheck2" class="form-check-label">
                    <small>
                      Durch die Anforderung dieses persönlichen Angebots bestätigen Sie, 
                      dass Sie auch in Zukunft weitere Informationen von uns zu 
                      dem Thema erhalten wollen. Diese Einwilligung erfolgt freiwillig 
                      und kann von Ihnen jederzeit widerrufen werden. Wir verarbeiten 
                      Ihre Daten datenschutzkonform. Details finden Sie in unserer 
                      <a class="datenschutz" href="/datenschutzerklaerung" target="_blank">Datenschutz</a>.*
                    </small>
                    <input type="checkbox" class="form-check-input datapriv" value="" id="defaultCheck2" required
                      v-model="dataprivacy">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="col-12 pl-0">
              <p class="duty mt-3">
                <small>*Pflichtfelder</small>
              </p>
            </div>

            <div v-if="Object.keys(errors).length" class="w-100 mt-3">
              <div class="row">
                <div class="col-12">
                  <div v-for="(v, k) in errors" :key="k">
                    <p v-for="error in v" :key="error" class="text-danger lh-1 mb-0">
                      <small class="font-weight-bold lh-1" v-html="error"></small>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 p-3">
                <button class="green-btn" :disabled="isLoading" type="submit">
                  ABSCHICKEN
                </button>
              </div>
            </div>

          </form>
          <div v-if="submitted">

            <div v-if="successful">
              <h2 class="success-header text-uppercase font-passion-one">Vielen Dank für Ihr Interesse!</h2>
              <p class="success-text">
                Ihre angegebenen Informationen sind bei uns eingegangen.<br> <br>
                Folgendes haben wir von Ihnen erhalten:<br> <br>
                <strong>Anrede: </strong> {{salutation}}<br>
                <strong>Vorname: </strong> {{firstname}}<br>
                <strong>Nachname: </strong> {{lastname}}<br>
                <strong>E-Mail: </strong> {{email}}<br>
                <span v-if="phone"><strong>Telefon: </strong> {{phone}} <br></span>
                <strong>PLZ: </strong> {{zipcode}}<br>
                <strong>Stadt: </strong> {{city}}<br>
                <span v-if="comment"><strong>Anmerkung: </strong> {{comment}}<br></span> <br>
                Sie erhalten in Kürze eine E-Mail, in der Sie Ihre E-Mail-Adresse bestätigen müssen.<br><br>
Wir werden uns in den nächsten Tagen bei Ihnen melden, um einen Termin zum Probe-Schweißen zu vereinbaren.
                <br> <br>
                Viele Grüße <br>
                Ihr SLV Team
              </p>
            </div>
            <div v-else>
              <div class="form-title kontakt-invalid">
                <h2 class="p-0"> Sie haben sich bereits regestriert.</h2>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: {
      contact: '',
      city: ''
    },
    data: function () {
      return {
        errors: {},
        isLoading: false,
        salutation: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        zipcode: '',
        comment: '',
        dataprivacy: false,
        successful: false,
        submitted: false,
      }
    },
    methods: {
      async sendData() {

        // Recaptcha
        // Execute reCAPTCHA and get the token
        const token = await new Promise((resolve, reject) => {
          grecaptcha.ready(function() {
            grecaptcha.execute('6LePtsEZAAAAAByhVC6TP5NErU7526KYZdgzHCK4', {action: 'submit'}).then(token => {
              resolve(token);
            });
          });
        });

        this.isLoading = true;
        let self = this;
        const url = '/api/appointment-submit';

        var formdata = new FormData();
        formdata.append('token', token);
        formdata.append('email', this.email);
        formdata.append('firstname', this.firstname);
        formdata.append('lastname', this.lastname);
        formdata.append('phone', this.phone);
        formdata.append('salutation', this.salutation);
        formdata.append('zipcode', this.zipcode);
        formdata.append('message', this.comment);
        formdata.append('formular', "Beratungsanfrage");
        formdata.append('contactEmail', this.contact);
        formdata.append('terms', this.dataprivacy);
        formdata.append('city', this.city);

        axios.post(url, formdata)
          .then(response => {
            if (response.data.success) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: "appointmentConversion",
              });
              self.submitted = true
              self.successful = true;
            }
          }).catch(function (error) {
              if (error.response.data.errors) {
                self.errors = error.response.data.errors;
              }
              self.isLoading = false;
          });
      }
    }
  }

</script>